import { useState } from "react";
import VehicleChildForm from "./components/vehicleChildForm";
import DriverChildForm from "./components/driverChildForm";
import DealershipChildForm from "./components/dealershipChildForm";
import { requiredFieldsByStep } from "./utils/required-fields-by-step";
import ErrorDialog from "../../../../components/dialogs/ErrorDialog";
import { IForm } from "../..";
import SuccessDialog from "../../../../components/dialogs/SuccessDialog";
import ServiceChildForm from "./components/serviceChildForm";
import { createServiceBaySchedule } from "../../../../api/serviceBay";

const NewOccurrenceForm = (props: IForm) => {

  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [hasError, setHasError] = useState(false);

  return (
    <div>
      <VehicleChildForm
        occurrence={props.occurrence}
        setOccurrence={props.setOccurrence}
        setOccurrenceValue={props.setOccurrenceValue}
        hiddenFields={[]}
        disabledFields={[
          'vehicleChassis',
        ]}
        requiredFields={requiredFieldsByStep.VEHICLE}
        disabledAllFields={props.disabledAllFields}
        setOccurrenceStepValue={props.setOccurrenceStepValue}
        hasError={hasError}
        scheduling={props.scheduling}
      />

      {/* <DriverChildForm
        occurrence={props.occurrence}
        setOccurrenceValue={props.setOccurrenceValue}
        hiddenFields={[]}
        disabledFields={[]}
        requiredFields={requiredFieldsByStep.DRIVER}
        disabledAllFields={props.disabledAllFields}
        setOccurrenceStepValue={props.setOccurrenceStepValue}
        hasError={hasError}
      /> */}

      <DealershipChildForm
        occurrence={props.occurrence}
        setOccurrence={props.setOccurrence}
        setOccurrenceValue={props.setOccurrenceValue}
        hiddenFields={[]}
        disabledFields={[
          'dealershipDn',
        ]}
        requiredFields={requiredFieldsByStep.DEALERSHIP}
        disabledAllFields={props.disabledAllFields}
        setOccurrenceStepValue={props.setOccurrenceStepValue}
        hasError={hasError}
      />

      <ServiceChildForm
        occurrence={props.occurrence}
        setOccurrenceValue={props.setOccurrenceValue}
        hiddenFields={[
          'estimatedTime',
          'partOrderStatus',
          'osNumber',
          'osDtOpenAt',
          'driverCheckInDriver',
          'mechanicLocation',
          'towTruckLocation',
          'literatureDiagnosis',
          'literatureTroubleshooting',
          'tasNumber',
          'tasStatus',
          'checklist',
          'solutionProposed',
        ]}
        disabledFields={['createdBy', 'dtStart', 'dtEnd']}
        requiredFields={requiredFieldsByStep.CALL}
        step={props.step}
        disabledAllFields={props.disabledAllFields}
        setOccurrenceStepValue={props.setOccurrenceStepValue}
        partners={props.partners}
        addDispatch={props.addDispatch}
        cancelDispatch={props.cancelDispatch}
        hasError={hasError}
        persona={props.persona}
        scheduling={props.scheduling}
      />

      {(props.persona !== 'MANAGER' && !props.finalized) && !props.hiddenSaveButton && <div className="flex justify-end">
        <button
          className={`btn btn-primary ${props.loading ? 'btn-loading disabled' : ''}`}
          type="button"
          onClick={async () => {
            if (!props.occurrence || !props.create) return;
            if (!props.isValidStep(requiredFieldsByStep.CALL)) return setHasError(true);
            setHasError(false);

            const {wasCreated, error} = await props.create({
              ...props.occurrence,
              steps: [{...props.step, latest: 0 }]
            });
            if (wasCreated) {
              if (props.occurrence.serviceBaySchedule) {
                // TODO: se der erro, desfazer o create da occurrence
                await createServiceBaySchedule({
                  ...props.occurrence.serviceBaySchedule,
                  occurrence: props.occurrence.serviceBaySchedule.occurrence?.id,
                  serviceBay: props.occurrence.serviceBaySchedule.serviceBay?.id,
                });
              }
              setShowSuccessDialog(true);
            } else {
              setErrorMessage(error || 'Ocorreu um erro ao criar o chamado. Por favor, tente novamente ou entre em contato com o suporte.');
              setShowErrorDialog(true);
            }
          }}
          disabled={props.loading || props.disabledAllFields}
        >Criar chamado</button>
      </div>}

      <ErrorDialog
        show={showErrorDialog}
        onClose={() => setShowErrorDialog(false)}
        title="Erro ao criar chamado"
        body={errorMessage}
      />

      <SuccessDialog
        show={showSuccessDialog}
        onClose={() => setShowSuccessDialog(false)}
        title="Chamado criado com sucesso"
        body="O chamado foi criado com sucesso."
      />
    </div>
  );
};

export default NewOccurrenceForm;